import React, { useState, useEffect } from 'react'

import 'web_common/css/LimnTech.css'
import { db } from 'web_common/tsx/api/db/Api'
import { Company, CompanyAdminPrivilege, LifemarkUserModel, ProcessedPathInfo } from 'web_common/tsx/api/db/Models'
import ApiError from 'web_common/tsx/components/misc/ApiError'
import PermissionDenied from 'web_common/tsx/components/misc/PermissionDenied'
import Loading from 'web_common/tsx/components/misc/Loading'

import ArchivedPathAdminTable from 'components/paths/archived/list/ArchivedPathAdminTable'
import ArchivedPathUserTable from 'components/paths/archived/list/ArchivedPathUserTable'

interface ArchivedPathListProps {

}

const ArchivedPathList: React.FC<ArchivedPathListProps> = (props) => {
    const [apiError, setApiError] = useState<boolean>(false)
    const [lifemarkUser, setLifemarkUser] = useState<LifemarkUserModel|undefined>(undefined)
    const [company, setCompany] = useState<Company|undefined>(undefined)
    const [processedPaths, setProcessedPaths] = useState<Array<ProcessedPathInfo>|undefined>(undefined)
    const [activatePending, setActivatePending] = useState<boolean>(false)

    useEffect(() => {
        const onCurrentUser = (response: LifemarkUserModel|undefined) => {
            if(response === undefined)
            {
                setApiError(true)
            }
            else
            {
                setLifemarkUser(response)
            }
        }

        db.current_user(onCurrentUser)
    }, [])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            const onCompany = (response: Company|undefined) => {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setCompany(response)
                }
            }

            db.company_detail(lifemarkUser.company, onCompany)
        }
    }, [lifemarkUser])

    useEffect(() => {
        if(lifemarkUser !== undefined && processedPaths === undefined)
        {
            const onCompletion = (response: Array<ProcessedPathInfo>|undefined) =>
            {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setProcessedPaths(response)
                }
            }

            db.processed_path_list(
                lifemarkUser.company,
                false,
                onCompletion)
        }
    }, [lifemarkUser, processedPaths])

    if(apiError === true)
    {
        return <ApiError/>
    }
    else if(activatePending === true)
    {
        return (
            <div className='limn-form-container'>
                <h1 className='limn-header'> Archived Paths </h1>
                <Loading/>
            </div>
        )
    }
    else if(lifemarkUser !== undefined)
    {
        if(lifemarkUser.privilege === CompanyAdminPrivilege.NONE)
        {
            return (
                <PermissionDenied/>
            )
        }
        else if(company !== undefined && processedPaths !== undefined)
        {
            if(lifemarkUser.privilege === CompanyAdminPrivilege.ADMIN)
            {
                return (
                    <div className='limn-form-container'>
                        <h1 className='limn-header'> Archived Paths </h1>
                        <ArchivedPathAdminTable
                            company={company}
                            processedPathList={processedPaths}
                            onActivatePending={()=>{
                                setActivatePending(true)
                            }}
                            onActivateFailure={()=>{
                                setApiError(true)
                                setActivatePending(false)
                            }}
                            onActivateSuccess={()=>{
                                setProcessedPaths(undefined)
                                setActivatePending(false)
                            }}
                        />
                    </div>
                )
            }
            else
            {
                return (
                    <div className='limn-form-container'>
                        <h1 className='limn-header'> Archived Paths </h1>
                        <ArchivedPathUserTable
                            processedPathList={processedPaths}
                        />
                    </div>
                )
            }
        }
        else
        {
           return (
                <div className='limn-form-container'>
                    <h1 className='limn-header'> Archived Paths </h1>
                    <Loading/>
                </div>
            )
        }
    }
    else
    {
        return (
            <div className='limn-form-container'>
                <h1 className='limn-header'> Archived Paths </h1>
                <Loading/>
            </div>
        )
    }
}

export default ArchivedPathList
